import { Checkbox, FormControlLabel, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CalendarEventSurveyResponses from "./CalendarEventSurveyResponses";

interface FormData {
    capacity: number | null;
    surveyAppointmentAllowed: boolean;
    surveyAppointmentReward: number | null;
}

interface Props {
    serviceModuleId: number;
    eventId: number;
    formData: Partial<FormData>;
    setFormData: (updated: Partial<FormData>) => void;
}

export default function CalendarEventSurveyDetails(props: Props) {
    const { t } = useTranslation();

    return <Stack>
        <Typography variant="subtitle2" sx={{ mt: 3 }}>Terminumfrage</Typography>
        <FormControlLabel
            label={t("serviceModulesPage.calendarPage.eventSurveyAllowed")}
            control={<Checkbox
                checked={props.formData.surveyAppointmentAllowed}
                onChange={(v) => props.setFormData({
                    surveyAppointmentAllowed: v.target.checked
                })} />}
        />
        {
            props.formData.surveyAppointmentAllowed && <>
                <Stack direction="row" gap={2}>
                    <TextField
                        type="number"
                        label={t("serviceModulesPage.calendarPage.eventCapacity")}
                        value={String(props.formData.capacity ?? "")}
                        onChange={(e) => props.setFormData({
                            capacity: e.target.value === "" ? null : Number(e.target.value),
                        })}
                        sx={{ my: 1, flex: 1 }}
                        inputProps={{ type: 'number' }}
                    />
                    <TextField
                        type="number"
                        label={t("serviceModulesPage.calendarPage.eventSurveyReward")}
                        value={String(props.formData.surveyAppointmentReward ?? "")}
                        onChange={(e) => props.setFormData({
                            surveyAppointmentReward: e.target.value === "" ? null : Number(e.target.value),
                        })}
                        sx={{ my: 1, flex: 1 }}
                        inputProps={{ type: 'number' }}
                    />
                </Stack>

                <CalendarEventSurveyResponses
                    eventId={props.eventId}
                    serviceModuleId={props.serviceModuleId}
                />
            </>
        }
    </Stack>
}